// Import the library
import React from "react";
import Datetime from 'react-datetime';
import moment from 'moment';

export default class MuzeDatetime extends React.Component {
    render() {
        var yesterday = moment().subtract(1, 'day');
        var valid = function (current) {
            return current.isAfter(yesterday);
        };
        return <Datetime name="lesson_date" className="modal-datetime"
                         isValidDate={valid}
                         inputProps={
                            {
                                placeholder: 'Select a Date and Time',
                                required: true
                            }
                        }
                         // Controlled: bind to the parent's value so the picker and
                         // the parent state can't diverge. When the parent resets the
                         // value to null after a submit, the picker clears too (an
                         // uncontrolled `initialValue` would keep showing the previous
                         // lesson's date while the bound state was null -> the next
                         // submit crashed on `null.format()`).
                         value={this.props.value || ''}
                         closeOnSelect={false}
                         onChange={this.props.onChange}
        />;
    }
} 